<div fxLayout="column" fxLayoutAlign="space-between stretch" fxLayoutGap="5px">
  <div>
    <app-field-label-required-actions
      [control]="control"
      [indexControl]="indexControl"
      [dialogComponent]="dialogComponent"
      (updateField)="onUpdatedControl($event)"
      (deleteField)="onDeletedControl($event)"></app-field-label-required-actions>
  </div>
  <div>
    <mat-divider></mat-divider>
    <mat-label class="mat-h5">Choix définis :</mat-label>
    <div class="ck_fields" fxFlex="calc(90% - 25px)">
      <ng-container *ngFor="let option of control.options.options">
        <span [class.horizontal]="control.options.horizontal" class="item">
          <input
          [placeholder]="control.options.placeholder" [type]="control.options.controlType"
          [value]="option.value">{{option.key}}
        </span>
      </ng-container>
    </div>
  </div>

</div>
